module.exports = __webpack_public_path__ + "img/editor-token.40aec66c.svg";